<template>


<TopBar />

<div class="main-container">

<SideBar />

<div class="main"> 


<section>

<div class="container" style="border-bottom: solid 1px #f0f0f0; padding-top: 10px; padding-bottom: 10px;">

<div class="row">

<div class="col-md-6 pt-3">
<h3> <i class="bi bi-bell color-1"></i> Notifications</h3>
</div>



</div>

</div>

</section>


<section style="padding-top:200px;" v-if="show_spinner==true">

<div style="text-align:center;">

<h6 class="text-secondary">Please wait...</h6>
<div class="spinner-border  text-info"></div>
</div>

</section>



<section v-if="show_spinner==false">
  
<div class="container">

    <div class="row">

    <div class="col-md-6">

      <div class="shadow  p-3 mt-3" style="border: solid 1px  #d7f1ff; border-radius: 15px; ">

       
    <h6 class="text-secondary"> Nothing to show... </h6>

        
      </div>
      
    </div>
    
  </div>

  
  
  
</div>

</section>




</div>




</div>


<Footer />

</template>



<script>

import Header from './layouts/Header'
import SideBar from './layouts/SideBar'
import TopBar from './layouts/TopBar'
import Footer from './layouts/Footer'
import axios from 'axios'

export default{
name : 'home',
components : { Header, SideBar, TopBar, Footer  },
data(){
return{
show_spinner : true
}
},

methods : {

},

created(){

setTimeout((data)=>{
this.show_spinner = false
}, 3000)
}


}

</script>






